export enum ETipoRps
{
    RPS = 0,
    NFConjugada = 1,
    Cupom = 2
}
